import { useGetReservationByIdQuery } from "@stepapp/core";
import { SafeAreaView } from "@stepapp/ui";
import { useLocalSearchParams, useRouter } from "expo-router";
import { useCallback, useState } from "react";
import { StyleSheet } from "react-native";
import { RetryPayment } from "../../src/screens";

const ReservationRetryPayment = () => {
  const { back } = useRouter();
  const [paymentMethodId, setPaymentMethodId] = useState("");

  const { reservationId = "" } = useLocalSearchParams<{ reservationId: string }>();

  const { data } = useGetReservationByIdQuery({
    variables: { orderId: reservationId, isCustomerApp: true },
    onCompleted(data) {
      setPaymentMethodId(data.getReservationById.payment?.paymentMethodId || "");
    },
  });

  const selectPaymentMethod = useCallback((id: string) => {
    setPaymentMethodId(id);
  }, []);

  const handleClose = useCallback(() => {
    setPaymentMethodId("");
    back();
  }, [back]);

  return (
    <SafeAreaView edges={["bottom"]} style={styles.container}>
      <RetryPayment
        onClose={handleClose}
        selectPaymentMethod={selectPaymentMethod}
        price={data?.getReservationById?.price}
        currency={data?.getReservationById?.currency}
        paymentId={data?.getReservationById?.payment?.id || ""}
        paymentMethodId={paymentMethodId}
        reservationId={reservationId}
      />
    </SafeAreaView>
  );
};

export default ReservationRetryPayment;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
